<template>
  <svg
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M101.798 5H18.2143C8.16964 5 0 13.1717 0 23.2143V78.8721C0 88.5965 7.66741 96.5653 17.2726 97.0508V109.353C17.2726 112.084 18.8002 114.522 21.257 115.715C22.2489 116.194 23.3035 116.431 24.3541 116.431C25.9068 116.431 27.4428 115.912 28.7277 114.901L40.7603 105.388C47.5405 100.027 56.0365 97.0738 64.6791 97.0738H101.786C111.83 97.0738 120 88.9042 120 78.8616V23.2038C120 13.1655 111.835 5 101.798 5ZM111.429 78.8616C111.429 84.1769 107.101 88.5024 101.786 88.5024H64.6791C54.1155 88.5024 43.7319 92.1101 35.445 98.6621L25.844 106.254V92.7881C25.844 90.4213 23.9272 88.5024 21.5583 88.5024H18.2017C12.8906 88.5024 8.57143 84.1832 8.57143 78.8721V23.2143C8.57143 17.8969 12.899 13.5714 18.2143 13.5714H101.798C107.109 13.5714 111.429 17.8927 111.429 23.2038V78.8616Z"
      fill="#FF6347"
    />
    <path
      d="M60 56.1104H34.2857C31.9169 56.1104 30 58.0293 30 60.3961C30 62.7628 31.9169 64.6818 34.2857 64.6818H60C62.3689 64.6818 64.2857 62.7628 64.2857 60.3961C64.2857 58.0293 62.3689 56.1104 60 56.1104Z"
      fill="#FF6347"
    />
    <path
      d="M85.7143 37.4082H34.2857C31.9169 37.4082 30 39.3271 30 41.6939C30 44.0607 31.9169 45.9796 34.2857 45.9796H85.7143C88.0831 45.9796 90 44.0607 90 41.6939C90 39.3271 88.0831 37.4082 85.7143 37.4082Z"
      fill="#FF6347"
    />
  </svg>
</template>
